"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompoundHitArea = void 0;
/**
 * Compound hit area
 */
var CompoundHitArea = /** @class */ (function () {
    function CompoundHitArea(pComponents) {
        this._components = pComponents;
    }
    Object.defineProperty(CompoundHitArea.prototype, "components", {
        /**
         * Gets components
         */
        get: function () {
            return this._components;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * contains
     * @param pX
     * @param pY
     * @returns boolean
     */
    CompoundHitArea.prototype.contains = function (pX, pY) {
        for (var i = 0; i < this._components.length; ++i) {
            if (this._components[i].contains(pX, pY)) {
                return true;
            }
        }
        return false;
    };
    return CompoundHitArea;
}());
exports.CompoundHitArea = CompoundHitArea;
//# sourceMappingURL=CompoundHitArea.js.map